__turbopack_context__.v({
  "blue": "ListItem-module-scss-module__3jyGcG__blue",
  "container": "ListItem-module-scss-module__3jyGcG__container",
  "green": "ListItem-module-scss-module__3jyGcG__green",
  "orange": "ListItem-module-scss-module__3jyGcG__orange",
  "pink": "ListItem-module-scss-module__3jyGcG__pink",
  "root": "ListItem-module-scss-module__3jyGcG__root",
});
